export function getLastActivity(lead) {
  let lastActivity = lead.CREATEDATE;
  if (lead.interactions.length > 0) {
    lead.interactions.forEach((interaction) => {
      if (parseInt(interaction.DATE) > parseInt(lastActivity)) {
        lastActivity = interaction.DATE;
      }
    });
  }

  const date = new Date(parseInt(lastActivity));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  const timeDiff = Math.abs(today - date);
  const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  const isNew = daysDiff <= 3 && lead.interactions.length == 0;

  let delayAlertIsDue = false;
  if (lead.ALERTDELAY) {
    const delayAlertDate = new Date(parseInt(lead.ALERTDELAY));
    delayAlertDate.setHours(0, 0, 0, 0);
    delayAlertIsDue = delayAlertDate <= today;
  }

  if (daysDiff >= 7 && (!lead.ALERTDELAY || delayAlertIsDue)) {
    lead.lastActivityAlert = true;
  }

  if (lead.COMPLETE) {
    return '';
  } else if (isNew) {
    return 'New';
  } else if (daysDiff === 0) {
    return 'Today';
  } else {
    return `${daysDiff} day${daysDiff > 1 ? 's' : ''}`;
  }
}
